import Component from 'react-pure-render/component';
import PropTypes from 'prop-types';
import React from 'react';
import SweetAlert from 'sweetalert-react';
import 'sweetalert/dist/sweetalert.css';

export default class ModalMessage extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    sender: PropTypes.object.isRequired,
    showCancelButton: PropTypes.bool,
    type: PropTypes.string,
    onCancel: PropTypes.func
  };

  static defaultProps = {
    type: 'error',
    showCancelButton: false
  };

  constructor(props) {
    super(props);
    this.state = { show: true };
  }

  internalOnClose = () => {
    const { onClose, sender } = this.props;

    this.setState({ show: false });

    onClose(sender);
  };

  internalOnCancel = () => {
    const { onCancel } = this.props;

    this.setState({ show: false });

    onCancel();
  };

  render() {
    const { message, title, type, showCancelButton } = this.props;
    const { show } = this.state;

    return (
      <SweetAlert
        show={show}
        showCancelButton={showCancelButton}
        type={type}
        title={title}
        text={message}
        onConfirm={this.internalOnClose}
        cancelButtonText="Cancelar"
        onCancel={this.internalOnCancel}
      />
    );
  }
}
